import { ChatSessionExpiredError } from 'assistant/domain/chatErrors'
import { isForbiddenError, isUnauthorizedError } from 'core/infra/http/errors'
import { type HttpClientInterface } from 'core/infra/http/HttpClient'

import { chatTokenUrl } from './chatApiUrls'

export { ChatSessionExpiredError }

type ChatTokenRepositoryDependencies = {
  httpClient: HttpClientInterface
  baseApiUrl: string
}

type ChatTokenResponse = { token: string; expires_at: string }

export class ChatTokenRepository {
  private httpClient: HttpClientInterface
  private baseApiUrl: string

  constructor({ httpClient, baseApiUrl }: ChatTokenRepositoryDependencies) {
    this.httpClient = httpClient
    this.baseApiUrl = baseApiUrl
  }

  async fetch() {
    try {
      const { data } = await this.httpClient.post<undefined, ChatTokenResponse>(
        chatTokenUrl(this.baseApiUrl)
      )

      return { token: data.token, expiresAt: data.expires_at }
    } catch (error) {
      // 401 (no credentials) and 403 (bad credentials, or the flag is off in
      // Django) both end the same way for the user.
      if (isUnauthorizedError(error) || isForbiddenError(error)) {
        throw new ChatSessionExpiredError()
      }

      throw error
    }
  }
}
